// Copyright © Veeam Software Group GmbH

import { useRouterActions } from '@veeam/core';

import type { RestoreSessionId } from 'services/restoreService';

// eslint-disable-next-line import/no-cycle
import { Routes } from '../index';

export interface RestoreSessionsRouting {
    goTo(sessionId?: RestoreSessionId): void;
    getQuery(): { sessionId?: RestoreSessionId; };
}

export function useRestoreSessionRouting(): RestoreSessionsRouting {
    const router = useRouterActions();
    const goTo = (sessionId?: RestoreSessionId): void => {
        if (router.isActive(Routes.RestoreSessions)) return;
        router.goTo(Routes.RestoreSessions, undefined, sessionId ? { sessionId } : undefined);
    };
    const getQuery = (): { sessionId?: RestoreSessionId; } => {
        const sessionId = router.getQuery().sessionId;
        if (typeof sessionId === 'string') return { sessionId: sessionId as RestoreSessionId };
        return {};
    };
    return { goTo, getQuery };
}
